import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ToastService from 'primevue/toastservice';
import Tooltip from 'primevue/tooltip';
import Vuelidate from 'vuelidate'
import moment from './plugin/moment';
import formatDate from './plugin/formatDate'
import papaparse from './plugin/papaparse'
import exportCsv from './plugin/exportCsv'

Vue.config.productionTip = false

Vue.use(ToastService)
Vue.directive('tooltip', Tooltip);
Vue.use(Vuelidate)
Vue.use(moment)
Vue.use(formatDate)
Vue.use(papaparse)
Vue.use(exportCsv)

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
